import branchesList from "./list";
import branchDetails from "./details";
import createBranch from "./create";
import branchSelector from "./selector";

export default {branchesList, branchDetails, createBranch, branchSelector};
